import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const API_END_POINT = process.env.API_END_POINT
const COMPANIES = API_END_POINT + '/company'
const MANIPULATOR_COMPANIES = API_END_POINT + '/manipulator/company'
const VACANCIES = API_END_POINT + '/vacancies'
const COMPANY_VACANCIES = COMPANIES + '/vacancies'

export default {
  API_END_POINT: API_END_POINT,
  getSavedUsersById () {

  },
  deleteVacancyById (token, id, data) {
    return axios({
      url: COMPANY_VACANCIES + '/' + id,
      method: 'delete',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateVacancyById (token, id, data) {
    return axios({
      url: COMPANY_VACANCIES + '/' + id,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  addVacancy (token, data) {
    return axios({
      url: COMPANY_VACANCIES,
      method: 'put',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getSimilarVacancies (token = '', id = '', params) {
    let options = {
      url: VACANCIES + '/' + id + '/similar',
      method: 'get',
      params: params
    }
    if (token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  },
  getVacancyByAlias (token = '', alias = '') {
    let options = {
      url: VACANCIES + '/alias/' + alias,
      method: 'get'
    }
    if (token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  },
  getManipulatorCompanyVacancyById (token, manipulatorId, id) {
    return axios({
      url: COMPANY_VACANCIES + '/' + id,
      method: 'get',
      params: {
        manipulatorId: manipulatorId
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getVacancyById (id = '') {
    return axios({
      url: VACANCIES + '/' + id,
      method: 'get'
    }).then(generateResponse, generateErrorResponse)
  },
  getVacancies (token = '', params = { page: 1 }) {
    let options = {
      url: VACANCIES,
      method: 'get',
      params: params
    }
    if (token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  },
  getCompanyVacancies (params = { page: 1 }) {
    return axios({
      url: VACANCIES,
      method: 'get',
      params: params
    }).then(generateResponse, generateErrorResponse)
  },
  deleteById (token, id, data) {
    return axios({
      url: MANIPULATOR_COMPANIES + '/' + id,
      method: 'delete',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateById (token, id, data) {
    return axios({
      url: MANIPULATOR_COMPANIES + '/' + id,
      method: 'post',
      data: {
        companyId: data.id,
        manipulatorId: data.manipulatorId,
        companyName: data.name,
        companySummary: data.summary,
        companyBenefits: data.tags,
        companyTelephone: data.telephone,
        companyCountry: data.country.code,
        companyCity: data.city,
        companyDistrict: data.district,
        companyAddress: data.address,
        companyMembers: data.members,
        companyLogo: data.logo.id,
        companyBanner: data.banner.id,
        companyWebsite: data.website,
        companyStage: data.stage,
        companyCategory: Array.isArray(data.category) ? data.category : [data.category],
        photos: data.photos,
        removedPhotos: data.removed,
        websites: data.websites
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  add (token, data) {
    return axios({
      url: MANIPULATOR_COMPANIES,
      method: 'post',
      data: {
        manipulatorId: data.manipulatorId,
        companyName: data.name,
        companySummary: data.summary,
        companyBenefits: data.tags,
        companyTelephone: data.telephone,
        companyCountry: data.country.code,
        companyCity: data.city,
        companyDistrict: data.district,
        companyAddress: data.address,
        companyMembers: data.members,
        companyLogo: data.logo.id,
        companyBanner: data.banner.id,
        companyWebsite: data.website,
        companyStage: data.stage,
        companyCategory: Array.isArray(data.category) ? data.category : [data.category],
        photos: data.photos,
        removedPhotos: data.removed,
        websites: data.websites
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getById () {

  },
  getByAlias (token = '', alias = '') {
    let options = {
      url: COMPANIES + '/alias/' + alias,
      method: 'get'
    }
    if (token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  },
  get (token = '', params = { page: 1 }) {
    let options = {
      url: COMPANIES,
      method: 'get',
      params: params
    }
    if (token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/companies.js